var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38076 2.03621C9.22583 1.7223 8.77821 1.7223 8.62329 2.03621L6.61778 6.09981C6.55626 6.22446 6.43734 6.31086 6.29978 6.33085L1.81534 6.98248C1.46892 7.03281 1.33059 7.45853 1.58127 7.70288L4.82624 10.8659C4.92578 10.963 4.9712 11.1028 4.9477 11.2398L4.18167 15.7061C4.12249 16.0511 4.48463 16.3142 4.79448 16.1513L8.80548 14.0426C8.92852 13.9779 9.07552 13.9779 9.19856 14.0426L13.2096 16.1513C13.5194 16.3142 13.8815 16.0511 13.8224 15.7061L13.0563 11.2398C13.0328 11.1028 13.0783 10.963 13.1778 10.8659L16.4228 7.70288C16.6734 7.45853 16.5351 7.03281 16.1887 6.98248L11.7043 6.33085C11.5667 6.31086 11.4478 6.22446 11.3863 6.09981L9.38076 2.03621Z",
    fill: "#FEC84B",
    stroke: "#FEC84B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/starFill.c613b943567de8c7982e7a8b10c1155a.svg";
export { ForwardRef as ReactComponent };